export const QueryString = () => {
  let qs = {};
  let search = location.search;
  if (/^\?/.test(search)) {
    search = search.substr(1).split('&');
    for (let i = 0, j, k; i < search.length; i += 1) {
      j = search[i];
      if (/=/.test(j)) {
        k = j.split('=');
        qs[k[0]] = /^[0-9]{1,}(\.[0-9]{1,})?/.test(k[1]) ? Number(k[1]) : k[1];
      }
    }
  }
  return qs;
};